// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site_wrapper.notfound{align-items:center;background:#0a90e1;display:flex;justify-content:center;text-align:center!important;width:100%}.notff,.notff_button{color:#fff!important}.notff_button{background:#0a90e1!important;display:block!important}button,label{visibility:visible!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
